export default {"src":"/_next/static/media/mediacube-small.c4bafe77.svg","height":32,"width":32,"blurWidth":0,"blurHeight":0};